import BasePage from "../modules/basePage";
import "alpinejs";
import "../modules/sui/components";

// Styles
import "../../css/pages/CopayPage.scss";

class CopayPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
    }
}

new CopayPage();
